import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-roles-privileges-skeleton',
  templateUrl: './roles-privileges-skeleton.component.html',
  styleUrls: ['./roles-privileges-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class RolesPrivilegesSkeletonComponent {
  readonly tableRows = [1, 2, 3, 4, 5];
  readonly tableCols = [1, 2, 3, 4, 5, 6];
  readonly formCols = [1, 2, 3, 4];
}